import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxPaginationModule } from "ngx-pagination";
import { RouterModule } from "@angular/router";
import { ClickOutsideDirective } from "./directives/click-outside.directive";
import { TeleportModule } from "./modules/teleport/teleport.module";
import { DatePickerComponent } from "./components/ui/date-picker/date-picker.component";
import { FormCheckboxComponent } from "./components/ui/form-checkbox/form-checkbox.component";
import { FormGroupComponent } from "./components/ui/form-group/form-group.component";
import { FormInputComponent } from "./components/ui/form-input/form-input.component";
import { FormLabelComponent } from "./components/ui/form-label/form-label.component";
import { TableCellComponent } from "./components/table/table-cell/table-cell.component";
import { ButtonComponent } from "./components/ui/button/button.component";
import { FormSimpleInputComponent } from "./components/ui/form-simple-input/form-simple-input.component";
import { QuestionnaireHostDirective } from "./directives/questionnaire-host.directive";
import { GreetingComponent } from "./components/layout/greeting/greeting.component";
import { DashboardComponent } from "../layouts/dashboard/dashboard.component";
import { DashboardHeaderComponent } from "./components/layout/dashboard-header/dashboard-header.component";
import { DashboardHeaderNavComponent } from "./components/layout/dashboard-header-nav/dashboard-header-nav.component";
import {
  DashboardHeaderUserDropdownComponent
} from "./components/layout/dashboard-header-user-dropdown/dashboard-header-user-dropdown.component";
import { PaginationComponent } from "./components/ui/pagination/pagination.component";
import { SpinnerComponent } from "./components/ui/spinner/spinner.component";
import { FormTextareaComponent } from "./components/ui/form-textarea/form-textarea.component";
import { ToasterModule } from "./modules/toaster/toaster.module";
import { TagListComponent } from './components/ui/tag-list/tag-list.component';
import { FilterPipe } from './pipes/filter.pipe';
import { OptionPipe } from './pipes/option.pipe';
import { OrdinalNumberPipe } from './pipes/ordinal-number.pipe';
import { StatusLabelPipe } from './pipes/status-label.pipe';
import { BlockInfoComponent } from './components/ui/block-info/block-info.component';
import { TooltipContainerComponent } from './components/ui/tooltip-container/tooltip-container.component';
import { SelectedUnitsComponent } from './components/ui/selected-units/selected-units.component';
import { TagManagerComponent } from './components/ui/tag-manager/tag-manager.component';
import { TagInputComponent } from './components/ui/tag-input/tag-input.component';
import { DropdownListComponent } from "./components/ui/dropdown/dropdown-list.component";
import { FormSelectSearchableComponent } from "./components/ui/form-select-searchable/form-select-searchable.component";

const directives = [
  ClickOutsideDirective,
  QuestionnaireHostDirective,
  FilterPipe,
  OptionPipe,
  OrdinalNumberPipe,
  StatusLabelPipe
];

const components = [
  DashboardComponent,
  DashboardHeaderComponent,
  DashboardHeaderNavComponent,
  DashboardHeaderUserDropdownComponent,
  PaginationComponent,
  DatePickerComponent,
  FormSelectSearchableComponent,
  FormCheckboxComponent,
  FormGroupComponent,
  FormInputComponent,
  FormSimpleInputComponent,
  FormTextareaComponent,
  FormLabelComponent,
  TableCellComponent,
  ButtonComponent,
  GreetingComponent,
  TagListComponent,
  TagInputComponent,
  BlockInfoComponent,
  TooltipContainerComponent,
  SelectedUnitsComponent,
  DropdownListComponent,
  TagManagerComponent
];

const modules = [
  RouterModule,
  TeleportModule,
  ReactiveFormsModule,
  FormsModule,
  NgxPaginationModule,
  ToasterModule,
  SpinnerComponent,
];

@NgModule({
  declarations: [
    ...directives,
    ...components,
  ],
  imports: [
    CommonModule,
    ...modules
  ],
  exports: [
    ...directives,
    ...components,
    ...modules,
  ]
})
export class SharedModule {}
